import type { BulkUserRow } from '@/types/bulkUserImport';

export type BulkUserPostImportStatus = 'code-sent' | 'credential-issued';

export function getBulkUserPostImportStatus(row: BulkUserRow): BulkUserPostImportStatus {
  if (row.mobileCredentialIssued) return 'credential-issued';
  if (row.hasMobile) return 'code-sent';
  return 'credential-issued';
}

export function countMobileCodeSentRows(rows: BulkUserRow[]): number {
  return rows.filter((row) => getBulkUserPostImportStatus(row) === 'code-sent').length;
}

export function buildBulkApproveUserMessage(count: number): string {
  return `Add ${count} ${count === 1 ? 'user' : 'users'}`;
}

export function buildBulkIssueAllMobileUserMessage(count: number): string {
  return count === 1
    ? 'Issue credential for 1 mobile user'
    : `Issue credential for ${count} mobile users`;
}

export function buildBulkIssueSingleMobileUserMessage(firstName: string, lastName: string): string {
  const name = `${firstName} ${lastName}`.trim() || 'this user';
  return `Issue credential for ${name}`;
}

export { BULK_CREDENTIAL_ISSUE_TIMING } from '@/config/bulkUserImportFlow';
